import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import FpxImage from '../../assets/fpx.png';
import ButtonWrapper from '../../components/ButtonWrapper';
import { Checkbox, Radio, Space } from 'antd';
import InputWrapper from '../../components/InputWrapper';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { bankNames, toLocaleStringFormate } from '../../helpingFunctions';
import SelectWrapper from "../../components/SelectWrapper";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { transactionApi } from '../../config/axiosConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { postMyrFPXCreateTransaction } from '../../redux/actions/postQrInitManual';
import { PlusOutlined } from '@ant-design/icons';
import DropdownWrapper from '../../components/FullScreenSelect';
import useIsMobile from '../../hooks/useIsMobile';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: absolute;
`;

const CardWrapper = styled.div`
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 0px;
  text-align: left;
`;

const Label = styled.label`
  display: block;
  margin-top: 15px;
  font-size: 0.9rem;
  color: #555;
`;

const Select = styled(Field)`
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
  background-color: #fff;
`;

const CheckboxWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const Footer = styled.footer`
  margin-top: 20px;
  font-size: 0.8rem;
  text-align: center;
  color: #aaa;
`;

const validationSchema = Yup.object().shape({
  // email: Yup.string().email('Invalid email').required('Email is required'),
  // name: Yup.string().required('Name is required'),
  paymentMode: Yup.string().required('Payment Mode is required'),
  bank: Yup.string().required('Please select a bank'),
});

const PayWithFPX = () => {
  const navigation = useNavigate()
  const dispatch = useDispatch()
  const params = useParams();
  const [trnxModel, setTrnxModel] = useState("")
  const [bankListLoading, setBankListLoading] = useState(false)
  const isMobile = useIsMobile();


  const [bankList, setBankList] = useState([])
  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  const fetchBankList = async (model, selectedExgId) => {
    if (!model) return; // Prevent fetching if model is empty
  
    try {
      const response = await transactionApi.get('/myr/transactionmyr/fpx-bank-list', {
        params: {
          model: trnxModel,
          exgId: selectedExgId
        }
      });      
      const transformedData = response.data?.data?.map(item => ({
        id: item.code,
        bankNameEng: item.displayName,
        isAvailable: item.isAvailable,
      }));
  
      transformedData?.sort((a, b) => {
        const firstLetterA = a.bankNameEng[0].toLowerCase();
        const firstLetterB = b.bankNameEng[0].toLowerCase();
        return firstLetterA.localeCompare(firstLetterB);
      });
  
      setBankList(transformedData);
    } catch (error) {
      console.error("Error fetching bank list:", error.message);
    } finally {
      setBankListLoading(false);
    }
  };
  
  // First Effect: Set trnxModel from verifyData
  useEffect(() => {
    if (verifyData?.trnxModel?.length > 0) {
      setTrnxModel(verifyData.trnxModel[0]);
    }
  }, [verifyData]);
  
  // Second Effect: Fetch bank list when trnxModel is updated
  useEffect(() => {
    if (trnxModel) {
      fetchBankList(trnxModel, verifyData?.exgId);
    }
  }, [trnxModel]);

  useEffect(() => {
    if (!verifyData) {
      navigation(`/myr/${params.id}`);
    } else if (verifyData.bypasspp === true || verifyData.bypasspp === "true") {
      const payload = {
        transactionId: verifyData.trxRef,
        type: "fpx",
        amount: verifyData.amount,
        sessionId: verifyData.sessionToken,
        userId: verifyData.merchantId,
        buyerBankId: verifyData.clientBuyerBankId,
        fpxPaymentMethod: "CASA",
        transactionModel: verifyData.clientTransactionModel,
      };
      if (verifyData.clientBuyerEmail && verifyData.clientBuyerEmail.trim() !== "") {
        payload.buyerEmail = verifyData.clientBuyerEmail.trim();
      }
      dispatch(postMyrFPXCreateTransaction(payload, navigation, params.id));
    }
  }, [verifyData]);

  const handleCancel = () => {
    const redirectionUrl = localStorage.getItem("redirectionUrl");
    if (redirectionUrl) {
      window.open(redirectionUrl, "_self");
      localStorage.removeItem("redirectionUrl");
    } else if (verifyData?.redirectUrl) {
      window.open(verifyData.redirectUrl, "_self");
    } else if (verifyData?.siteUrl) {
      window.open(verifyData.siteUrl, "_self");
    } else {
      navigation(`/myr/${params.id}`);
    }
  };

  return (
    <Container>
      <CardWrapper>
        <div className="d-flex align-items-center" style={{ marginTop: '6rem' }}>
          <Title>PAY WITH</Title>
          <img src={FpxImage} alt="FPX" className="ms-3" />
        </div>
        <Formik
          initialValues={{
            email: null,
            // name: '',
            paymentMode: verifyData?.trnxModel?.includes("B2B") ? "Corporate Banking" : "Retail Banking",
            bank: '',
            agree: false,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            let getBank = bankList?.find(item => item.bankNameEng === values.bank)
            let payload = {
              "transactionId": verifyData?.trxRef,
              "type": "fpx",
              "amount": verifyData?.amount,
              "sessionId": verifyData?.sessionToken,
              "userId": verifyData?.merchantId,
              "buyerBankId": getBank?.id,
              "buyerEmail": values?.email,
              "fpxPaymentMethod": "CASA",
              'transactionModel': trnxModel
            }
            dispatch(postMyrFPXCreateTransaction(payload, navigation, params.id))
          }}
        >
          {({ errors, touched, values, handleChange }) => (
            <Form>
              {verifyData?.amount < 1 && verifyData?.trnxModel?.includes("B2C") ?
                <div style={{ margin: '30px 0' }}>
                  <p style={{ fontWeight: 'bold', color: 'red', marginBottom: 0, textAlign: 'center' }}>Unable to proceed!</p>
                  <p style={{ color: 'red', textAlign: "center" }}>Transaction Amount is Lower than the minimum Limit RM1.00 for B2C</p>
                </div>
                :
                verifyData?.amount < 2 && verifyData?.trnxModel?.includes("B2B") ?
                  <div style={{ margin: '30px 0' }}>
                    <p style={{ fontWeight: 'bold', color: 'red', marginBottom: 0, textAlign: 'center' }}>Unable to proceed!</p>
                    <p style={{ color: 'red', textAlign: "center" }}>Transaction Amount is Lower than the minimum Limit RM2.00 for B2B</p>
                  </div>
                  : null
              }

              {/* <Label>Merchant Name:</Label> */}
              <p style={{marginBottom: 50}}>{verifyData?.merchantName}</p>
              <Label>Amount:</Label>
              <p>RM {toLocaleStringFormate(verifyData?.amount)}</p>
              <Label>Reference ID:</Label>
              <p>{verifyData?.trxRef}</p>

              <Label>Email (Optional):</Label>
              <InputWrapper
                style={{ borderRadius: 10, marginTop: 0 }}
                name="email"
                type="text"
                size="large"
                placeholder="Please provide your email address"
                value={values.email}
                onChange={handleChange("email")}
              />
              {errors.email && touched.email ? (
                <div style={{ color: 'red' }}>{errors.email}</div>
              ) : null}


              <Label>Payment Mode:</Label>
              {/* {verifyData?.trnxModel ?
                <InputWrapper
                  style={{ borderRadius: 10, marginTop: 0 }}
                  name="paymentMode"
                  disabled
                  type="text"
                  size="large"
                  placeholder="Please provide your payment mode"
                  value={verifyData?.trnxModel.includes("B2B") ? "Corporate Banking" : "Retail Banking"}
                  onChange={handleChange("paymentMode")}
                />
                : */}
                <Radio.Group
                  className=""
                  onChange={(e) => setTrnxModel(e.target.value)}
                  value={trnxModel}
                >
                  <Space direction="horizontal" className="flex items-center">
                    {verifyData?.trnxModel?.includes("B2C") &&
                    <Radio
                      value={"B2C"}
                      className="d-flex justify-content-center align-items-center"
                    >
                      Retail Banking (B2C)
                    </Radio>}

                    {verifyData?.trnxModel?.includes("B2B") &&
                    <Radio
                      value={"B2B"}
                      className="d-flex justify-content-center align-items-center"
                    >
                      Corporate Banking (B2B)
                    </Radio>}
                  </Space>
                </Radio.Group>
              {/* } */}
              {errors.paymentMode && touched.paymentMode ? (
                <div style={{ color: 'red' }}>{errors.paymentMode}</div>
              ) : null}

              <Label>Select Bank:</Label>
              {isMobile ? (
                <DropdownWrapper
                  loading={bankListLoading}
                  name="bank"
                  size="large"
                  value={values.bank}
                  placeholder="Select bank"
                  bankMenu={bankList}
                  onChange={handleChange("bank")}
                />
              ) : (
                <SelectWrapper
                  showSearch
                  loading={bankListLoading}
                  name="bank"
                  size="large"
                  value={values.bank === "" ? null : <span>{values.bank}</span>}
                  placeholder="Select bank"
                  bankMenu={bankList}
                  onChange={handleChange("bank")}
                />
              )}
              {errors.bank && touched.bank ? (
                <div style={{ color: 'red' }}>{errors.bank}</div>
              ) : null}

              <CheckboxWrapper>
                <Checkbox name="agree" checked={values.agree} onChange={handleChange("agree")} />
                <span className='ms-2'>
                  By clicking on the “Proceed” button, you hereby agree with FPX’s{' '}
                  <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => window.location.href = "https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp"}
                  >
                    Terms & Conditions
                  </span>
                </span>
              </CheckboxWrapper>

              <ButtonGroup>
                <ButtonWrapper
                  border={true}
                  size="middle"
                  height="40px"
                  htmlType="button"
                  text="Cancel"
                  onClick={handleCancel}
                />
                <ButtonWrapper
                  // disabled={!values.agree || verifyData?.amount < 1 || verifyData?.amount === undefined}
                  disabled={!values.agree}
                  loading={qrInitLoading}
                  border={true}
                  bgColor="#003363"
                  type="primary"
                  color="#fff"
                  size="middle"
                  height="40px"
                  htmlType="submit"
                  text="Proceed"
                />
              </ButtonGroup>
            </Form>
          )}
        </Formik>
        <div className="d-flex align-items-center justify-content-end my-4">
          <Title style={{fontSize: 18, color:'grey', fontWeight: 'bold'}}>Powered by</Title>
          <img src={FpxImage} alt="FPX" className="ms-3" />
        </div>
        <Footer>Papaya Pay Sdn Bhd © {new Date().getFullYear()} All Rights Reserved</Footer>
      </CardWrapper>
    </Container>
  );
};

export default PayWithFPX;
